/**
 * "Recently Viewed" API slice (access/activity audit log, Increment 1).
 *
 *   GET /api/v1/crm/recently-viewed?instanceId=<uuid>
 *
 * Self-scoped: the server keys on the authenticated user's email — there is no
 * user param. Returns the caller's ~10 most-recently-opened records
 * (person / referrer person / resident / episode), newest-first, each with a
 * CURRENT display name resolved server-side under its visibility gate. The type
 * LABEL is applied on the FE via useTerm() (Prospect/Client, Referrer,
 * Resident) — the server returns only the raw resource_type.
 *
 * instanceId is passed as an EXPLICIT arg (mirrors packsApi/crmOverviewApi) so
 * it lands in the RTK Query cache key — a no-reload instance switch produces a
 * new key → refetch, instead of serving the previous instance's recents.
 */
import { baseApi } from "./baseApi";

export type RecentsResourceType = "person" | "referrer_person" | "resident" | "episode";

export interface RecentlyViewedItem {
  resource_type: RecentsResourceType;
  resource_id: string;
  display_name: string;
  last_viewed_at: string;
}

export interface RecentlyViewedResponse {
  items: RecentlyViewedItem[];
}

export const crmRecentlyViewedApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRecentlyViewed: builder.query<RecentlyViewedResponse, { instanceId: string }>({
      query: ({ instanceId }) => ({
        url: "/crm/recently-viewed",
        params: { instanceId },
      }),
    }),
  }),
});

export const { useGetRecentlyViewedQuery } = crmRecentlyViewedApi;
